import type { ProjectionRow } from '@/calc/projection';
import { formatLkr } from '@/lib/format';

export function SavingsProjection({ rows }: { rows: ProjectionRow[] }) {
  return (
    <>
      {/* Mobile: cards */}
      <div className="sm:hidden space-y-2">
        {rows.map((r) => (
          <div key={r.years} className="rounded-lg border border-slate-200 bg-white p-3">
            <div className="flex items-baseline justify-between mb-2">
              <div className="text-sm font-medium text-slate-700">
                {r.years} year{r.years > 1 ? 's' : ''}
                <span className="ml-1 text-xs text-slate-400">({r.cycles} cycle{r.cycles === 1 ? '' : 's'})</span>
              </div>
              <div className="text-base font-semibold text-slate-900 tabular-nums">
                {formatLkr(r.totalSavingLkr)}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-2 text-xs text-slate-600">
              <div>
                <div className="text-slate-500">Electricity</div>
                <div className="tabular-nums">{formatLkr(r.electricitySavingLkr)}</div>
              </div>
              <div>
                <div className="text-slate-500">Maintenance</div>
                <div className="tabular-nums">{formatLkr(r.maintenanceSavingLkr)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Tablet+: table */}
      <div className="hidden sm:block overflow-hidden rounded-lg border border-slate-200">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600">
            <tr>
              <th className="text-left px-4 py-2 font-medium">Period</th>
              <th className="text-right px-4 py-2 font-medium">Electricity saving</th>
              <th className="text-right px-4 py-2 font-medium">Maintenance saving</th>
              <th className="text-right px-4 py-2 font-medium">Total</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.years} className="border-t border-slate-100">
                <td className="px-4 py-2 text-slate-600">
                  {r.years} year{r.years > 1 ? 's' : ''}
                  <span className="text-xs text-slate-400 ml-1">({r.cycles} cycle{r.cycles === 1 ? '' : 's'})</span>
                </td>
                <td className="px-4 py-2 text-right tabular-nums">{formatLkr(r.electricitySavingLkr)}</td>
                <td className="px-4 py-2 text-right tabular-nums">{formatLkr(r.maintenanceSavingLkr)}</td>
                <td className="px-4 py-2 text-right tabular-nums font-semibold text-slate-900">
                  {formatLkr(r.totalSavingLkr)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
